import type { HeaderProps } from 'components/Header/interfaces';
import type { UseCustomerMenuProps } from '../../interfaces';
import { getMenuItems } from './helpers';
import { roleParser } from 'pages/pos/ManageAccess/helpers';

export default function useCustomerMenu({
	headerType,
	hyperaRole,
	customerName: userName,
	selectedPosId,
	showHelpButton,
	customerPosRole,
	customerRestriction,
	incentiveCampaignFlags,
	orderImportControls,
	logout,
}: UseCustomerMenuProps): Pick<HeaderProps, 'userMenu' | 'showHelpButton'> {
	const userRole = (() => {
		if (hyperaRole === 'CONSULTANT') return 'Consultor';
		if (hyperaRole === 'SUPERVISOR') return 'Supervisor';

		if (customerRestriction === 'SIMULATED') return 'Simulado';

		if (customerPosRole) return roleParser(customerPosRole);

		return undefined;
	})();

	const userMenu: HeaderProps['userMenu'] = {
		data: getMenuItems({ customerRestriction, selectedPosId, incentiveCampaignFlags, orderImportControls }),
		userName,
		userRole,
		linkToSimulated: customerRestriction === 'SIMULATED' ? '/simular-farmacia' : undefined,
		onLogout: logout,
	};

	return {
		userMenu,
		showHelpButton: customerRestriction === '2FA_EXPIRED' || headerType === 'not_logged' || showHelpButton,
	};
}
